import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getCaptureById, updateCapture as updateCaptureApi } from "../../api/captures/capture";
import { UpdateCaptureRequest } from "../../types/model/capture";

export const useCapture = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const result = useQuery({
    queryKey: ["capture", captureId, "general"],
    queryFn: () => getCaptureById(captureId),
    enabled: !!captureId,
  });

  const updateMutation = useMutation({
    mutationFn: (values: UpdateCaptureRequest) => updateCaptureApi(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["capture", captureId] });
    },
  });

  return {
    captureData: result.data,
    updateCapture: updateMutation.mutateAsync,
    isPending: result.isPending,
    isUpdating: updateMutation.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};
